import type { WorkerTaskEfficiency } from "./types";

export const efficiencyKey = (workerId: string, taskId: string) => `${workerId}:${taskId}`;
export const efficiencySource = (value?: WorkerTaskEfficiency) => !value ? "미설정" : value.source === "manual" ? "수동 수정" : "초기 계산";
export const efficiencySignature = (value?: WorkerTaskEfficiency) => JSON.stringify(value ? [value.id, value.unitsPerHour, value.smvMinutes, value.source, value.updatedAt, value.updatedBy] : null);
export function formatEfficiency(value: number) {
  // A positive rate must never look like 0 (which excludes the worker from planning).
  return value !== 0 && Math.abs(value) < .0001 ? value.toLocaleString("ko-KR", { maximumSignificantDigits: 4 }) : value.toLocaleString("ko-KR", { maximumFractionDigits: 4 });
}
export function efficiencyInputError(value: string) {
  if (!value.trim()) return "시간당 생산량을 입력해 주세요.";
  const rate = Number(value);
  return !Number.isFinite(rate) || rate < 0 || rate > 1_000_000 ? "0~1,000,000 사이의 숫자로 입력해 주세요." : undefined;
}
export function smvInputError(value: string) {
  if (!value.trim()) return "SMV를 입력해 주세요.";
  const minutes = Number(value);
  return !Number.isFinite(minutes) || minutes < 0.001 || minutes > 600 ? "SMV는 0.001~600분 사이여야 합니다." : undefined;
}
